export default "__VITE_PUBLIC_ASSET__4bf8ac14__"